import { RECIPE_SORT_TYPE } from '@fdc/constants/sort-type.constants';
import { useSearchOptions } from '@fdc/hooks/useSearchOptions';
import { getRecipeTagSearchInput } from '@fdc/utils/recipe-search-utils';

import { useRecipeSearch } from './useRecipeSearch';

export const useRecipeSearchTag = (
  tags: string[],
  pageSize?: number,
  excludeRecipeIds?: string[]
) => {
  const options = useSearchOptions(RECIPE_SORT_TYPE);
  const searchInput = getRecipeTagSearchInput(tags, {
    ...options,
    pageSize,
    excludeRecipeIds,
  });
  const result = useRecipeSearch(searchInput);

  return {
    ...result,
    options,
  };
};
